import { Component, HostListener } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfirmationResult } from '../shared/_constants';

@Component({
  selector: 'app-privacynotice-dialog',
  templateUrl: './privacynotice-dialog.component.html',
})
@HostListener('scroll', ['$event'])
export class PrivacyNoticeDialogComponent {
  isActive = false;

  constructor(private activeModal: NgbActiveModal) {}

  public async close() {
    this.activeModal.close(ConfirmationResult.no);
  }

  public async acknowledge() {
    this.activeModal.close(ConfirmationResult.yes);
  }

  activateButtonOnScroll(event: any) {
    // visible height + pixel scrolled >= total height
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }
  }

  scroll(element) {
    if (element != null) {
      element.scrollIntoView();
    }
  }
}
